export interface MediaItem {
  processed: boolean;
  metadata: {
    size: number;
    dimensions: string;
  };
  media_type: string;
  s3_key: string;
  media_id: string;
  created_at: string;
  created_by?: string;
  cloudfront_url: string;
  tags: string[];
}

/** Backend may send IMAGE, image, photo, etc. */
export function isImageMediaType(mediaType: string | undefined): boolean {
  const t = (mediaType || '').trim().toLowerCase();
  return t === 'image' || t === 'photo' || t === 'picture';
}

export function isDocumentMediaType(mediaType: string | undefined): boolean {
  const t = (mediaType || '').trim().toLowerCase();
  return t === 'document' || t === 'pdf';
}

const IMAGE_EXT = /\.(jpe?g|png|gif|webp|avif|bmp)(\?|#|$)/i;
const DOCUMENT_EXT = /\.pdf(\?|#|$)/i;

/** Use when `media_type` is missing or inconsistent (some APIs omit it). */
export function isImageMediaItem(item: Pick<MediaItem, 'media_type' | 's3_key'>): boolean {
  const t = (item.media_type || '').trim().toLowerCase();
  if (t === 'video' || t === 'audio' || t === 'document') return false;
  if (isImageMediaType(item.media_type)) return true;
  const key = item.s3_key?.toLowerCase() ?? '';
  return IMAGE_EXT.test(key);
}

export function isDocumentMediaItem(item: Pick<MediaItem, 'media_type' | 's3_key'>): boolean {
  if (isDocumentMediaType(item.media_type)) return true;
  const key = item.s3_key?.toLowerCase() ?? '';
  return DOCUMENT_EXT.test(key);
}

/** Prefer `cloudfront_url`; fall back to common alternate keys from APIs. */
export function getMediaThumbnailUrl(item: MediaItem): string {
  const r = item as MediaItem & {
    url?: string;
    signed_url?: string;
    thumbnail_url?: string;
    cdn_url?: string;
    public_url?: string;
  };
  return (
    (item.cloudfront_url || '').trim() ||
    (r.url || '').trim() ||
    (r.signed_url || '').trim() ||
    (r.thumbnail_url || '').trim() ||
    (r.cdn_url || '').trim() ||
    (r.public_url || '').trim()
  );
}
